import { useHMSActions } from "@100mslive/react-sdk";
import type { ProviderUnblockAudio } from "../types";
import { HMS_ERRORS, useHMSErrorCode } from "./useHMSErrorCode";

export const useHMSUnblockAudio = (): ProviderUnblockAudio => {
  const errorCode = useHMSErrorCode();
  const hmsActions = useHMSActions();

  const isAudioBlocked = errorCode === HMS_ERRORS.AUDIO_BLOCKED;

  const unblockAudio = async () => {
    await hmsActions.unblockAudio();
  };

  return {
    isAudioBlocked,
    unblockAudio,
  };
};
